import { useEffect, useRef, type RefObject } from "react"
import type FullCalendar from "@fullcalendar/react"

/**
 * 컨테이너 resize를 감지해서 FullCalendar.updateSize()를 호출.
 * WidgetPalette 열림/닫힘 등으로 그리드 너비가 바뀔 때 캘린더가 새 크기에 맞춰지도록.
 */
export function useCalendarResize(
  calendarRef: RefObject<FullCalendar | null>,
  containerRef: RefObject<HTMLElement | null>,
) {
  const rafId = useRef(0)

  useEffect(() => {
    const el = containerRef.current
    if (!el) return

    const observer = new ResizeObserver(() => {
      cancelAnimationFrame(rafId.current)
      rafId.current = requestAnimationFrame(() => {
        calendarRef.current?.getApi().updateSize()
      })
    })

    observer.observe(el)

    return () => {
      cancelAnimationFrame(rafId.current)
      observer.disconnect()
    }
  }, [calendarRef, containerRef])
}
